import React, { useState, useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'
import { apiGetLayoutsForSocialNetwork } from 'services/SocialNetworkService'
import { Select } from 'components/ui'
// import { HiOutlineSearch } from 'react-icons/hi'
import { useDispatch, useSelector } from 'react-redux'
import { setTableData } from '../store/dataSlice'
import cloneDeep from 'lodash/cloneDeep'
import { useTranslation } from 'react-i18next';
import { injectReducer } from 'store/index';
import reducer from '../../SocialNetworkForm/store';
import { setSelectedLayout } from 'views/socialnetwork/SocialNetworkForm/store/dataSlice'

injectReducer('SelectedSocialsForm', reducer)

const SocialNetworkTableLayout = () => {
	const [layouts, setLayouts] = useState([]);
	const [defaultLayout, setDefaultLayout] = useState(null);
	const { locale } = useSelector((state) => state.theme);

	const fetchLayouts = async () => {
		const response = await apiGetLayoutsForSocialNetwork()
		setLayouts(response.data);
	}

	let nameLocale = '';

	if (locale === 'sq') {
		nameLocale = 'nameSq';
	} else if (locale === 'en') {
		nameLocale = 'nameEn';
	} else if (locale === 'sr') {
		nameLocale = 'nameSr';
	} else {
		nameLocale = 'nameSq';
	};

	const getOptionLabel = (option) => option[nameLocale];
	const getOptionValue = (option) => option.id;
	const dispatch = useDispatch();
	const tableData = useSelector((state) => state.socialnetworksList.data.tableData)
	const changedLayout = useSelector((state) => state.SelectedSocialsForm.data.changedLayout);

	useEffect(() => {
		if (isEmpty(layouts)) {
			fetchLayouts();
		} else if (!defaultLayout && layouts.length > 0) {
			if (changedLayout) {
				setDefaultLayout(changedLayout);
				const newTableData = cloneDeep(tableData);
				newTableData.layoutId = changedLayout.id;
				dispatch(setTableData(newTableData));
				dispatch(setSelectedLayout(changedLayout));
			} else {
				setDefaultLayout(layouts[0]);
				const newTableData = cloneDeep(tableData);
				newTableData.layoutId = layouts[0].id;
				dispatch(setTableData(newTableData));
				dispatch(setSelectedLayout(layouts[0]));
			}
		}
	}, [layouts]);

	const onLayoutChange = (option) => {
		setDefaultLayout(option);
		const newTableData = cloneDeep(tableData);
		newTableData.layoutId = option.id;
		newTableData.pageIndex = 1;
		dispatch(setTableData(newTableData));
		dispatch(setSelectedLayout(option));
	};

	const { t } = useTranslation();

	return (
		<Select
			className="lg:ml-2 lg:mr-2 xl:w-52 lg:w-full w-full md:w-full md:mb-0 mb-4"
			options={layouts}
			placeholder={t('dropdown.LayoutPlaceholder')}
			onChange={onLayoutChange}
			getOptionLabel={getOptionLabel}
			getOptionValue={getOptionValue}
			value={defaultLayout}
		/>
	)
}

export default SocialNetworkTableLayout